// Auto-generated from assets/es-window-map.json
// Loaded via <script> to avoid CORS limitations of fetching JSON from cdn.shopify.com.
window.__ES_WINDOW_MAP__ = {
  "6x8_p": {
    "sizeKey": "6x8",
    "orientation": "p",
    "sizeMm": {"w":152,"h":203},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":485,"y":646,"w":530,"h":708},"artwork":{"x":485,"y":646,"w":530,"h":708},"frame":{"x":412,"y":573,"w":676,"h":854},"frameWidthPx":73,"mountBorderPx":0},
    "framed_m1": {"window":{"x":590,"y":751,"w":320,"h":498},"artwork":{"x":485,"y":646,"w":530,"h":708},"frame":{"x":412,"y":573,"w":676,"h":854},"frameWidthPx":73,"mountBorderPx":105},
    "unframed": {"window":{"x":412,"y":548,"w":677,"h":904},"artwork":{"x":412,"y":548,"w":677,"h":904},"frameWidthPx":0,"mountBorderPx":0}
  },
  "6x8_l": {
    "sizeKey": "6x8",
    "orientation": "l",
    "sizeMm": {"w":203,"h":152},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":470,"y":790,"w":561,"h":420},"artwork":{"x":470,"y":790,"w":561,"h":420},"frame":{"x":412,"y":732,"w":677,"h":536},"frameWidthPx":58,"mountBorderPx":0},
    "framed_m1": {"window":{"x":553,"y":873,"w":395,"h":254},"artwork":{"x":470,"y":790,"w":561,"h":420},"frame":{"x":412,"y":732,"w":677,"h":536},"frameWidthPx":58,"mountBorderPx":83},
    "unframed": {"window":{"x":412,"y":747,"w":677,"h":507},"artwork":{"x":412,"y":747,"w":677,"h":507},"frameWidthPx":0,"mountBorderPx":0}
  },
  "8x10_p": {
    "sizeKey": "8x10",
    "orientation": "p",
    "sizeMm": {"w":203,"h":254},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":455,"y":631,"w":590,"h":738},"artwork":{"x":455,"y":631,"w":590,"h":738},"frame":{"x":394,"y":570,"w":712,"h":860},"frameWidthPx":61,"mountBorderPx":0},
    "framed_m1": {"window":{"x":571,"y":747,"w":358,"h":506},"artwork":{"x":455,"y":631,"w":590,"h":738},"frame":{"x":394,"y":570,"w":712,"h":860},"frameWidthPx":61,"mountBorderPx":116},
    "unframed": {"window":{"x":394,"y":555,"w":712,"h":891},"artwork":{"x":394,"y":555,"w":712,"h":891},"frameWidthPx":0,"mountBorderPx":0}
  },
  "8x10_l": {
    "sizeKey": "8x10",
    "orientation": "l",
    "sizeMm": {"w":254,"h":203},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":445,"y":756,"w":611,"h":488},"artwork":{"x":445,"y":756,"w":611,"h":488},"frame":{"x":394,"y":705,"w":713,"h":590},"frameWidthPx":51,"mountBorderPx":0},
    "framed_m1": {"window":{"x":541,"y":852,"w":419,"h":296},"artwork":{"x":445,"y":756,"w":611,"h":488},"frame":{"x":394,"y":705,"w":713,"h":590},"frameWidthPx":51,"mountBorderPx":96},
    "unframed": {"window":{"x":394,"y":716,"w":712,"h":569},"artwork":{"x":394,"y":716,"w":712,"h":569},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a4_p": {
    "sizeKey": "a4",
    "orientation": "p",
    "sizeMm": {"w":210,"h":297},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":446,"y":569,"w":609,"h":862},"artwork":{"x":446,"y":569,"w":609,"h":862},"frame":{"x":385,"y":508,"w":731,"h":984},"frameWidthPx":61,"mountBorderPx":0},
    "framed_m1": {"window":{"x":562,"y":685,"w":377,"h":630},"artwork":{"x":446,"y":569,"w":609,"h":862},"frame":{"x":385,"y":508,"w":731,"h":984},"frameWidthPx":61,"mountBorderPx":116},
    "unframed": {"window":{"x":398,"y":502,"w":704,"h":996},"artwork":{"x":398,"y":502,"w":704,"h":996},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a4_l": {
    "sizeKey": "a4",
    "orientation": "l",
    "sizeMm": {"w":297,"h":210},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":430,"y":774,"w":641,"h":453},"artwork":{"x":430,"y":774,"w":641,"h":453},"frame":{"x":385,"y":729,"w":731,"h":543},"frameWidthPx":45,"mountBorderPx":0},
    "framed_m1": {"window":{"x":516,"y":860,"w":469,"h":281},"artwork":{"x":430,"y":774,"w":641,"h":453},"frame":{"x":385,"y":729,"w":731,"h":543},"frameWidthPx":45,"mountBorderPx":86},
    "unframed": {"window":{"x":385,"y":742,"w":731,"h":517},"artwork":{"x":385,"y":742,"w":731,"h":517},"frameWidthPx":0,"mountBorderPx":0}
  },
  "8x12_p": {
    "sizeKey": "8x12",
    "orientation": "p",
    "sizeMm": {"w":203,"h":305},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":458,"y":562,"w":584,"h":877},"artwork":{"x":458,"y":562,"w":584,"h":877},"frame":{"x":398,"y":502,"w":704,"h":997},"frameWidthPx":60,"mountBorderPx":0},
    "framed_m1": {"window":{"x":573,"y":677,"w":354,"h":647},"artwork":{"x":458,"y":562,"w":584,"h":877},"frame":{"x":398,"y":502,"w":704,"h":997},"frameWidthPx":60,"mountBorderPx":115},
    "unframed": {"window":{"x":418,"y":501,"w":664,"h":998},"artwork":{"x":418,"y":501,"w":664,"h":998},"frameWidthPx":0,"mountBorderPx":0}
  },
  "8x12_l": {
    "sizeKey": "8x12",
    "orientation": "l",
    "sizeMm": {"w":305,"h":203},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":428,"y":786,"w":644,"h":429},"artwork":{"x":428,"y":786,"w":644,"h":429},"frame":{"x":384,"y":742,"w":732,"h":517},"frameWidthPx":44,"mountBorderPx":0},
    "framed_m1": {"window":{"x":512,"y":870,"w":476,"h":261},"artwork":{"x":428,"y":786,"w":644,"h":429},"frame":{"x":384,"y":742,"w":732,"h":517},"frameWidthPx":44,"mountBorderPx":84},
    "unframed": {"window":{"x":384,"y":756,"w":733,"h":488},"artwork":{"x":384,"y":756,"w":733,"h":488},"frameWidthPx":0,"mountBorderPx":0}
  },
  "11x14_p": {
    "sizeKey": "11x14",
    "orientation": "p",
    "sizeMm": {"w":279,"h":356},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":414,"y":571,"w":673,"h":859},"artwork":{"x":414,"y":571,"w":673,"h":859},"frame":{"x":363,"y":520,"w":775,"h":961},"frameWidthPx":51,"mountBorderPx":0},
    "framed_m1": {"window":{"x":511,"y":668,"w":479,"h":665},"artwork":{"x":414,"y":571,"w":673,"h":859},"frame":{"x":363,"y":520,"w":775,"h":961},"frameWidthPx":51,"mountBorderPx":97},
    "unframed": {"window":{"x":363,"y":506,"w":775,"h":989},"artwork":{"x":363,"y":506,"w":775,"h":989},"frameWidthPx":0,"mountBorderPx":0}
  },
  "11x14_l": {
    "sizeKey": "11x14",
    "orientation": "l",
    "sizeMm": {"w":356,"h":279},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":404,"y":729,"w":693,"h":543},"artwork":{"x":404,"y":729,"w":693,"h":543},"frame":{"x":363,"y":688,"w":775,"h":625},"frameWidthPx":41,"mountBorderPx":0},
    "framed_m1": {"window":{"x":482,"y":807,"w":537,"h":387},"artwork":{"x":404,"y":729,"w":693,"h":543},"frame":{"x":363,"y":688,"w":775,"h":625},"frameWidthPx":41,"mountBorderPx":78},
    "unframed": {"window":{"x":363,"y":697,"w":775,"h":607},"artwork":{"x":363,"y":697,"w":775,"h":607},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a3_p": {
    "sizeKey": "a3",
    "orientation": "p",
    "sizeMm": {"w":297,"h":420},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":398,"y":501,"w":705,"h":998},"artwork":{"x":398,"y":501,"w":705,"h":998},"frame":{"x":348,"y":451,"w":805,"h":1098},"frameWidthPx":50,"mountBorderPx":0},
    "framed_m1": {"window":{"x":517,"y":620,"w":467,"h":760},"artwork":{"x":398,"y":501,"w":705,"h":998},"frame":{"x":348,"y":451,"w":805,"h":1098},"frameWidthPx":50,"mountBorderPx":119},
    "unframed": {"window":{"x":362,"y":452,"w":776,"h":1097},"artwork":{"x":362,"y":452,"w":776,"h":1097},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a3_l": {
    "sizeKey": "a3",
    "orientation": "l",
    "sizeMm": {"w":420,"h":297},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":384,"y":741,"w":732,"h":518},"artwork":{"x":384,"y":741,"w":732,"h":518},"frame":{"x":347,"y":704,"w":806,"h":592},"frameWidthPx":37,"mountBorderPx":0},
    "framed_m1": {"window":{"x":471,"y":828,"w":558,"h":344},"artwork":{"x":384,"y":741,"w":732,"h":518},"frame":{"x":347,"y":704,"w":806,"h":592},"frameWidthPx":37,"mountBorderPx":87},
    "unframed": {"window":{"x":348,"y":715,"w":805,"h":570},"artwork":{"x":348,"y":715,"w":805,"h":570},"frameWidthPx":0,"mountBorderPx":0}
  },
  "12x16_p": {
    "sizeKey": "12x16",
    "orientation": "p",
    "sizeMm": {"w":305,"h":406},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":398,"y":531,"w":705,"h":939},"artwork":{"x":398,"y":531,"w":705,"h":939},"frame":{"x":349,"y":482,"w":803,"h":1037},"frameWidthPx":49,"mountBorderPx":0},
    "framed_m1": {"window":{"x":514,"y":647,"w":473,"h":707},"artwork":{"x":398,"y":531,"w":705,"h":939},"frame":{"x":349,"y":482,"w":803,"h":1037},"frameWidthPx":49,"mountBorderPx":116},
    "unframed": {"window":{"x":349,"y":466,"w":802,"h":1068},"artwork":{"x":349,"y":466,"w":802,"h":1068},"frameWidthPx":0,"mountBorderPx":0}
  },
  "12x16_l": {
    "sizeKey": "12x16",
    "orientation": "l",
    "sizeMm": {"w":406,"h":305},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":387,"y":727,"w":727,"h":546},"artwork":{"x":387,"y":727,"w":727,"h":546},"frame":{"x":349,"y":689,"w":803,"h":622},"frameWidthPx":38,"mountBorderPx":0},
    "framed_m1": {"window":{"x":477,"y":817,"w":547,"h":366},"artwork":{"x":387,"y":727,"w":727,"h":546},"frame":{"x":349,"y":689,"w":803,"h":622},"frameWidthPx":38,"mountBorderPx":90},
    "unframed": {"window":{"x":349,"y":699,"w":802,"h":603},"artwork":{"x":349,"y":699,"w":802,"h":603},"frameWidthPx":0,"mountBorderPx":0}
  },
  "12x18_p": {
    "sizeKey": "12x18",
    "orientation": "p",
    "sizeMm": {"w":305,"h":457},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":408,"y":487,"w":685,"h":1026},"artwork":{"x":408,"y":487,"w":685,"h":1026},"frame":{"x":361,"y":440,"w":779,"h":1120},"frameWidthPx":47,"mountBorderPx":0},
    "framed_m1": {"window":{"x":520,"y":599,"w":461,"h":802},"artwork":{"x":408,"y":487,"w":685,"h":1026},"frame":{"x":361,"y":440,"w":779,"h":1120},"frameWidthPx":47,"mountBorderPx":112},
    "unframed": {"window":{"x":376,"y":440,"w":748,"h":1121},"artwork":{"x":376,"y":440,"w":748,"h":1121},"frameWidthPx":0,"mountBorderPx":0}
  },
  "12x18_l": {
    "sizeKey": "12x18",
    "orientation": "l",
    "sizeMm": {"w":457,"h":305},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":374,"y":749,"w":753,"h":503},"artwork":{"x":374,"y":749,"w":753,"h":503},"frame":{"x":339,"y":714,"w":823,"h":573},"frameWidthPx":35,"mountBorderPx":0},
    "framed_m1": {"window":{"x":456,"y":831,"w":589,"h":339},"artwork":{"x":374,"y":749,"w":753,"h":503},"frame":{"x":339,"y":714,"w":823,"h":573},"frameWidthPx":35,"mountBorderPx":82},
    "unframed": {"window":{"x":339,"y":726,"w":823,"h":549},"artwork":{"x":339,"y":726,"w":823,"h":549},"frameWidthPx":0,"mountBorderPx":0}
  },
  "16x20_p": {
    "sizeKey": "16x20",
    "orientation": "p",
    "sizeMm": {"w":406,"h":508},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":355,"y":506,"w":791,"h":989},"artwork":{"x":355,"y":506,"w":791,"h":989},"frame":{"x":314,"y":465,"w":873,"h":1071},"frameWidthPx":41,"mountBorderPx":0},
    "framed_m1": {"window":{"x":452,"y":603,"w":597,"h":795},"artwork":{"x":355,"y":506,"w":791,"h":989},"frame":{"x":314,"y":465,"w":873,"h":1071},"frameWidthPx":41,"mountBorderPx":97},
    "unframed": {"window":{"x":314,"y":454,"w":872,"h":1092},"artwork":{"x":314,"y":454,"w":872,"h":1092},"frameWidthPx":0,"mountBorderPx":0}
  },
  "16x20_l": {
    "sizeKey": "16x20",
    "orientation": "l",
    "sizeMm": {"w":508,"h":406},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":347,"y":678,"w":806,"h":644},"artwork":{"x":347,"y":678,"w":806,"h":644},"frame":{"x":314,"y":645,"w":872,"h":710},"frameWidthPx":33,"mountBorderPx":0},
    "framed_m1": {"window":{"x":426,"y":757,"w":648,"h":486},"artwork":{"x":347,"y":678,"w":806,"h":644},"frame":{"x":314,"y":645,"w":872,"h":710},"frameWidthPx":33,"mountBorderPx":79},
    "unframed": {"window":{"x":314,"y":652,"w":872,"h":697},"artwork":{"x":314,"y":652,"w":872,"h":697},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a2_p": {
    "sizeKey": "a2",
    "orientation": "p",
    "sizeMm": {"w":420,"h":594},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":341,"y":421,"w":819,"h":1158},"artwork":{"x":341,"y":421,"w":819,"h":1158},"frame":{"x":300,"y":380,"w":901,"h":1240},"frameWidthPx":41,"mountBorderPx":0},
    "framed_m1": {"window":{"x":439,"y":519,"w":623,"h":962},"artwork":{"x":341,"y":421,"w":819,"h":1158},"frame":{"x":300,"y":380,"w":901,"h":1240},"frameWidthPx":41,"mountBorderPx":98},
    "unframed": {"window":{"x":312,"y":380,"w":877,"h":1240},"artwork":{"x":312,"y":380,"w":877,"h":1240},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a2_l": {
    "sizeKey": "a2",
    "orientation": "l",
    "sizeMm": {"w":594,"h":420},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":325,"y":700,"w":850,"h":601},"artwork":{"x":325,"y":700,"w":850,"h":601},"frame":{"x":295,"y":670,"w":910,"h":661},"frameWidthPx":30,"mountBorderPx":0},
    "framed_m1": {"window":{"x":397,"y":772,"w":706,"h":457},"artwork":{"x":325,"y":700,"w":850,"h":601},"frame":{"x":295,"y":670,"w":910,"h":661},"frameWidthPx":30,"mountBorderPx":72},
    "unframed": {"window":{"x":295,"y":678,"w":910,"h":644},"artwork":{"x":295,"y":678,"w":910,"h":644},"frameWidthPx":0,"mountBorderPx":0}
  },
  "18x24_p": {
    "sizeKey": "18x24",
    "orientation": "p",
    "sizeMm": {"w":457,"h":610},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":326,"y":433,"w":849,"h":1134},"artwork":{"x":326,"y":433,"w":849,"h":1134},"frame":{"x":287,"y":394,"w":927,"h":1212},"frameWidthPx":39,"mountBorderPx":0},
    "framed_m1": {"window":{"x":419,"y":526,"w":663,"h":948},"artwork":{"x":326,"y":433,"w":849,"h":1134},"frame":{"x":287,"y":394,"w":927,"h":1212},"frameWidthPx":39,"mountBorderPx":93},
    "unframed": {"window":{"x":286,"y":381,"w":928,"h":1238},"artwork":{"x":286,"y":381,"w":928,"h":1238},"frameWidthPx":0,"mountBorderPx":0}
  },
  "18x24_l": {
    "sizeKey": "18x24",
    "orientation": "l",
    "sizeMm": {"w":610,"h":457},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":316,"y":675,"w":868,"h":650},"artwork":{"x":316,"y":675,"w":868,"h":650},"frame":{"x":286,"y":645,"w":928,"h":710},"frameWidthPx":30,"mountBorderPx":0},
    "framed_m1": {"window":{"x":387,"y":746,"w":726,"h":508},"artwork":{"x":316,"y":675,"w":868,"h":650},"frame":{"x":286,"y":645,"w":928,"h":710},"frameWidthPx":30,"mountBorderPx":71},
    "unframed": {"window":{"x":286,"y":653,"w":928,"h":695},"artwork":{"x":286,"y":653,"w":928,"h":695},"frameWidthPx":0,"mountBorderPx":0}
  },
  "20x28_p": {
    "sizeKey": "20x28",
    "orientation": "p",
    "sizeMm": {"w":508,"h":711},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":299,"y":368,"w":903,"h":1264},"artwork":{"x":299,"y":368,"w":903,"h":1264},"frame":{"x":262,"y":331,"w":977,"h":1338},"frameWidthPx":37,"mountBorderPx":0},
    "framed_m1": {"window":{"x":388,"y":457,"w":725,"h":1086},"artwork":{"x":299,"y":368,"w":903,"h":1264},"frame":{"x":262,"y":331,"w":977,"h":1338},"frameWidthPx":37,"mountBorderPx":89},
    "unframed": {"window":{"x":272,"y":331,"w":956,"h":1339},"artwork":{"x":272,"y":331,"w":956,"h":1339},"frameWidthPx":0,"mountBorderPx":0}
  },
  "20x28_l": {
    "sizeKey": "20x28",
    "orientation": "l",
    "sizeMm": {"w":711,"h":508},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":286,"y":669,"w":928,"h":663},"artwork":{"x":286,"y":669,"w":928,"h":663},"frame":{"x":259,"y":642,"w":982,"h":717},"frameWidthPx":27,"mountBorderPx":0},
    "framed_m1": {"window":{"x":351,"y":734,"w":798,"h":533},"artwork":{"x":286,"y":669,"w":928,"h":663},"frame":{"x":259,"y":642,"w":982,"h":717},"frameWidthPx":27,"mountBorderPx":65},
    "unframed": {"window":{"x":259,"y":649,"w":983,"h":702},"artwork":{"x":259,"y":649,"w":983,"h":702},"frameWidthPx":0,"mountBorderPx":0}
  },
  "20x30_p": {
    "sizeKey": "20x30",
    "orientation": "p",
    "sizeMm": {"w":508,"h":762},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":318,"y":353,"w":864,"h":1295},"artwork":{"x":318,"y":353,"w":864,"h":1295},"frame":{"x":282,"y":317,"w":936,"h":1367},"frameWidthPx":36,"mountBorderPx":0},
    "framed_m1": {"window":{"x":403,"y":438,"w":694,"h":1125},"artwork":{"x":318,"y":353,"w":864,"h":1295},"frame":{"x":282,"y":317,"w":936,"h":1367},"frameWidthPx":36,"mountBorderPx":85},
    "unframed": {"window":{"x":295,"y":317,"w":911,"h":1367},"artwork":{"x":295,"y":317,"w":911,"h":1367},"frameWidthPx":0,"mountBorderPx":0}
  },
  "20x30_l": {
    "sizeKey": "20x30",
    "orientation": "l",
    "sizeMm": {"w":762,"h":508},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":275,"y":683,"w":951,"h":634},"artwork":{"x":275,"y":683,"w":951,"h":634},"frame":{"x":249,"y":657,"w":1003,"h":686},"frameWidthPx":26,"mountBorderPx":0},
    "framed_m1": {"window":{"x":337,"y":745,"w":827,"h":510},"artwork":{"x":275,"y":683,"w":951,"h":634},"frame":{"x":249,"y":657,"w":1003,"h":686},"frameWidthPx":26,"mountBorderPx":62},
    "unframed": {"window":{"x":249,"y":666,"w":1003,"h":669},"artwork":{"x":249,"y":666,"w":1003,"h":669},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a1_p": {
    "sizeKey": "a1",
    "orientation": "p",
    "sizeMm": {"w":594,"h":841},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":265,"y":313,"w":971,"h":1374},"artwork":{"x":265,"y":313,"w":971,"h":1374},"frame":{"x":231,"y":279,"w":1039,"h":1442},"frameWidthPx":34,"mountBorderPx":0},
    "framed_m1": {"window":{"x":347,"y":395,"w":807,"h":1210},"artwork":{"x":265,"y":313,"w":971,"h":1374},"frame":{"x":231,"y":279,"w":1039,"h":1442},"frameWidthPx":34,"mountBorderPx":82},
    "unframed": {"window":{"x":241,"y":279,"w":1019,"h":1443},"artwork":{"x":241,"y":279,"w":1019,"h":1443},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a1_l": {
    "sizeKey": "a1",
    "orientation": "l",
    "sizeMm": {"w":841,"h":594},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":246,"y":644,"w":1009,"h":713},"artwork":{"x":246,"y":644,"w":1009,"h":713},"frame":{"x":221,"y":619,"w":1059,"h":763},"frameWidthPx":25,"mountBorderPx":0},
    "framed_m1": {"window":{"x":306,"y":704,"w":889,"h":593},"artwork":{"x":246,"y":644,"w":1009,"h":713},"frame":{"x":221,"y":619,"w":1059,"h":763},"frameWidthPx":25,"mountBorderPx":60},
    "unframed": {"window":{"x":221,"y":626,"w":1059,"h":748},"artwork":{"x":221,"y":626,"w":1059,"h":748},"frameWidthPx":0,"mountBorderPx":0}
  },
  "24x32_p": {
    "sizeKey": "24x32",
    "orientation": "p",
    "sizeMm": {"w":610,"h":813},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":258,"y":344,"w":985,"h":1313},"artwork":{"x":258,"y":344,"w":985,"h":1313},"frame":{"x":224,"y":310,"w":1053,"h":1381},"frameWidthPx":34,"mountBorderPx":0},
    "framed_m1": {"window":{"x":339,"y":425,"w":823,"h":1151},"artwork":{"x":258,"y":344,"w":985,"h":1313},"frame":{"x":224,"y":310,"w":1053,"h":1381},"frameWidthPx":34,"mountBorderPx":81},
    "unframed": {"window":{"x":224,"y":299,"w":1053,"h":1403},"artwork":{"x":224,"y":299,"w":1053,"h":1403},"frameWidthPx":0,"mountBorderPx":0}
  },
  "24x32_l": {
    "sizeKey": "24x32",
    "orientation": "l",
    "sizeMm": {"w":813,"h":610},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":250,"y":625,"w":1001,"h":751},"artwork":{"x":250,"y":625,"w":1001,"h":751},"frame":{"x":224,"y":599,"w":1053,"h":803},"frameWidthPx":26,"mountBorderPx":0},
    "framed_m1": {"window":{"x":312,"y":687,"w":877,"h":627},"artwork":{"x":250,"y":625,"w":1001,"h":751},"frame":{"x":224,"y":599,"w":1053,"h":803},"frameWidthPx":26,"mountBorderPx":62},
    "unframed": {"window":{"x":224,"y":605,"w":1053,"h":790},"artwork":{"x":224,"y":605,"w":1053,"h":790},"frameWidthPx":0,"mountBorderPx":0}
  },
  "24x36_p": {
    "sizeKey": "24x36",
    "orientation": "p",
    "sizeMm": {"w":610,"h":914},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":275,"y":288,"w":950,"h":1424},"artwork":{"x":275,"y":288,"w":950,"h":1424},"frame":{"x":242,"y":255,"w":1016,"h":1490},"frameWidthPx":33,"mountBorderPx":0},
    "framed_m1": {"window":{"x":353,"y":366,"w":794,"h":1268},"artwork":{"x":275,"y":288,"w":950,"h":1424},"frame":{"x":242,"y":255,"w":1016,"h":1490},"frameWidthPx":33,"mountBorderPx":78},
    "unframed": {"window":{"x":253,"y":255,"w":994,"h":1490},"artwork":{"x":253,"y":255,"w":994,"h":1490},"frameWidthPx":0,"mountBorderPx":0}
  },
  "24x36_l": {
    "sizeKey": "24x36",
    "orientation": "l",
    "sizeMm": {"w":914,"h":610},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":228,"y":651,"w":1045,"h":698},"artwork":{"x":228,"y":651,"w":1045,"h":698},"frame":{"x":204,"y":627,"w":1093,"h":746},"frameWidthPx":24,"mountBorderPx":0},
    "framed_m1": {"window":{"x":285,"y":708,"w":931,"h":584},"artwork":{"x":228,"y":651,"w":1045,"h":698},"frame":{"x":204,"y":627,"w":1093,"h":746},"frameWidthPx":24,"mountBorderPx":57},
    "unframed": {"window":{"x":204,"y":635,"w":1093,"h":730},"artwork":{"x":204,"y":635,"w":1093,"h":730},"frameWidthPx":0,"mountBorderPx":0}
  },
  "24x30_p": {
    "sizeKey": "24x30",
    "orientation": "p",
    "sizeMm": {"w":610,"h":762},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":185,"y":294,"w":1131,"h":1412},"artwork":{"x":185,"y":294,"w":1131,"h":1412},"frame":{"x":146,"y":255,"w":1209,"h":1490},"frameWidthPx":39,"mountBorderPx":0},
    "framed_m1": {"window":{"x":278,"y":387,"w":945,"h":1226},"artwork":{"x":185,"y":294,"w":1131,"h":1412},"frame":{"x":146,"y":255,"w":1209,"h":1490},"frameWidthPx":39,"mountBorderPx":93},
    "unframed": {"window":{"x":146,"y":245,"w":1209,"h":1510},"artwork":{"x":146,"y":245,"w":1209,"h":1510},"frameWidthPx":0,"mountBorderPx":0}
  },
  "24x30_l": {
    "sizeKey": "24x30",
    "orientation": "l",
    "sizeMm": {"w":762,"h":610},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":178,"y":542,"w":1145,"h":917},"artwork":{"x":178,"y":542,"w":1145,"h":917},"frame":{"x":146,"y":510,"w":1209,"h":981},"frameWidthPx":32,"mountBorderPx":0},
    "framed_m1": {"window":{"x":253,"y":617,"w":995,"h":767},"artwork":{"x":178,"y":542,"w":1145,"h":917},"frame":{"x":146,"y":510,"w":1209,"h":981},"frameWidthPx":32,"mountBorderPx":75},
    "unframed": {"window":{"x":146,"y":517,"w":1209,"h":967},"artwork":{"x":146,"y":517,"w":1209,"h":967},"frameWidthPx":0,"mountBorderPx":0}
  },
  "32x40_p": {
    "sizeKey": "32x40",
    "orientation": "p",
    "sizeMm": {"w":813,"h":1016},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":87,"y":171,"w":1327,"h":1659},"artwork":{"x":87,"y":171,"w":1327,"h":1659},"frame":{"x":53,"y":137,"w":1395,"h":1727},"frameWidthPx":34,"mountBorderPx":0},
    "framed_m1": {"window":{"x":169,"y":253,"w":1163,"h":1495},"artwork":{"x":87,"y":171,"w":1327,"h":1659},"frame":{"x":53,"y":137,"w":1395,"h":1727},"frameWidthPx":34,"mountBorderPx":82},
    "unframed": {"window":{"x":52,"y":128,"w":1396,"h":1745},"artwork":{"x":52,"y":128,"w":1396,"h":1745},"frameWidthPx":0,"mountBorderPx":0}
  },
  "32x40_l": {
    "sizeKey": "32x40",
    "orientation": "l",
    "sizeMm": {"w":1016,"h":813},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":80,"y":464,"w":1341,"h":1073},"artwork":{"x":80,"y":464,"w":1341,"h":1073},"frame":{"x":52,"y":436,"w":1397,"h":1129},"frameWidthPx":28,"mountBorderPx":0},
    "framed_m1": {"window":{"x":146,"y":530,"w":1209,"h":941},"artwork":{"x":80,"y":464,"w":1341,"h":1073},"frame":{"x":52,"y":436,"w":1397,"h":1129},"frameWidthPx":28,"mountBorderPx":66},
    "unframed": {"window":{"x":52,"y":442,"w":1396,"h":1117},"artwork":{"x":52,"y":442,"w":1396,"h":1117},"frameWidthPx":0,"mountBorderPx":0}
  },
  "28x40_p": {
    "sizeKey": "28x40",
    "orientation": "p",
    "sizeMm": {"w":711,"h":1016},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":218,"y":239,"w":1065,"h":1522},"artwork":{"x":218,"y":239,"w":1065,"h":1522},"frame":{"x":187,"y":208,"w":1127,"h":1584},"frameWidthPx":31,"mountBorderPx":0},
    "framed_m1": {"window":{"x":308,"y":329,"w":885,"h":1342},"artwork":{"x":218,"y":239,"w":1065,"h":1522},"frame":{"x":187,"y":208,"w":1127,"h":1584},"frameWidthPx":31,"mountBorderPx":90},
    "unframed": {"window":{"x":196,"y":208,"w":1109,"h":1584},"artwork":{"x":196,"y":208,"w":1109,"h":1584},"frameWidthPx":0,"mountBorderPx":0}
  },
  "28x40_l": {
    "sizeKey": "28x40",
    "orientation": "l",
    "sizeMm": {"w":1016,"h":711},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":192,"y":609,"w":1117,"h":782},"artwork":{"x":192,"y":609,"w":1117,"h":782},"frame":{"x":169,"y":586,"w":1163,"h":828},"frameWidthPx":23,"mountBorderPx":0},
    "framed_m1": {"window":{"x":258,"y":675,"w":985,"h":650},"artwork":{"x":192,"y":609,"w":1117,"h":782},"frame":{"x":169,"y":586,"w":1163,"h":828},"frameWidthPx":23,"mountBorderPx":66},
    "unframed": {"window":{"x":169,"y":593,"w":1163,"h":814},"artwork":{"x":169,"y":593,"w":1163,"h":814},"frameWidthPx":0,"mountBorderPx":0}
  },
  "30x40_p": {
    "sizeKey": "30x40",
    "orientation": "p",
    "sizeMm": {"w":762,"h":1016},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":192,"y":256,"w":1116,"h":1488},"artwork":{"x":192,"y":256,"w":1116,"h":1488},"frame":{"x":161,"y":225,"w":1178,"h":1550},"frameWidthPx":31,"mountBorderPx":0},
    "framed_m1": {"window":{"x":280,"y":344,"w":940,"h":1312},"artwork":{"x":192,"y":256,"w":1116,"h":1488},"frame":{"x":161,"y":225,"w":1178,"h":1550},"frameWidthPx":31,"mountBorderPx":88},
    "unframed": {"window":{"x":161,"y":215,"w":1178,"h":1570},"artwork":{"x":161,"y":215,"w":1178,"h":1570},"frameWidthPx":0,"mountBorderPx":0}
  },
  "30x40_l": {
    "sizeKey": "30x40",
    "orientation": "l",
    "sizeMm": {"w":1016,"h":762},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":185,"y":576,"w":1131,"h":848},"artwork":{"x":185,"y":576,"w":1131,"h":848},"frame":{"x":162,"y":553,"w":1177,"h":894},"frameWidthPx":23,"mountBorderPx":0},
    "framed_m1": {"window":{"x":252,"y":643,"w":997,"h":714},"artwork":{"x":185,"y":576,"w":1131,"h":848},"frame":{"x":162,"y":553,"w":1177,"h":894},"frameWidthPx":23,"mountBorderPx":67},
    "unframed": {"window":{"x":161,"y":559,"w":1178,"h":883},"artwork":{"x":161,"y":559,"w":1178,"h":883},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a0_p": {
    "sizeKey": "a0",
    "orientation": "p",
    "sizeMm": {"w":841,"h":1189},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":159,"y":165,"w":1182,"h":1671},"artwork":{"x":159,"y":165,"w":1182,"h":1671},"frame":{"x":129,"y":135,"w":1242,"h":1731},"frameWidthPx":30,"mountBorderPx":0},
    "framed_m1": {"window":{"x":229,"y":235,"w":1042,"h":1531},"artwork":{"x":159,"y":165,"w":1182,"h":1671},"frame":{"x":129,"y":135,"w":1242,"h":1731},"frameWidthPx":30,"mountBorderPx":70},
    "unframed": {"window":{"x":139,"y":135,"w":1223,"h":1730},"artwork":{"x":139,"y":135,"w":1223,"h":1730},"frameWidthPx":0,"mountBorderPx":0}
  },
  "a0_l": {
    "sizeKey": "a0",
    "orientation": "l",
    "sizeMm": {"w":1189,"h":841},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":137,"y":567,"w":1226,"h":867},"artwork":{"x":137,"y":567,"w":1226,"h":867},"frame":{"x":115,"y":545,"w":1270,"h":911},"frameWidthPx":22,"mountBorderPx":0},
    "framed_m1": {"window":{"x":189,"y":619,"w":1122,"h":763},"artwork":{"x":137,"y":567,"w":1226,"h":867},"frame":{"x":115,"y":545,"w":1270,"h":911},"frameWidthPx":22,"mountBorderPx":52},
    "unframed": {"window":{"x":115,"y":551,"w":1270,"h":898},"artwork":{"x":115,"y":551,"w":1270,"h":898},"frameWidthPx":0,"mountBorderPx":0}
  },
  "12x12_s": {
    "sizeKey": "12x12",
    "orientation": "s",
    "sizeMm": {"w":305,"h":305},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":414,"y":664,"w":672,"h":672},"artwork":{"x":414,"y":664,"w":672,"h":672},"frame":{"x":368,"y":618,"w":764,"h":764},"frameWidthPx":46,"mountBorderPx":0},
    "framed_m1": {"window":{"x":502,"y":752,"w":496,"h":496},"artwork":{"x":414,"y":664,"w":672,"h":672},"frame":{"x":368,"y":618,"w":764,"h":764},"frameWidthPx":46,"mountBorderPx":88},
    "unframed": {"window":{"x":368,"y":618,"w":765,"h":765},"artwork":{"x":368,"y":618,"w":765,"h":765},"frameWidthPx":0,"mountBorderPx":0}
  },
  "16x16_s": {
    "sizeKey": "16x16",
    "orientation": "s",
    "sizeMm": {"w":406,"h":406},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":372,"y":622,"w":757,"h":757},"artwork":{"x":372,"y":622,"w":757,"h":757},"frame":{"x":333,"y":583,"w":835,"h":835},"frameWidthPx":39,"mountBorderPx":0},
    "framed_m1": {"window":{"x":465,"y":715,"w":571,"h":571},"artwork":{"x":372,"y":622,"w":757,"h":757},"frame":{"x":333,"y":583,"w":835,"h":835},"frameWidthPx":39,"mountBorderPx":93},
    "unframed": {"window":{"x":333,"y":583,"w":835,"h":835},"artwork":{"x":333,"y":583,"w":835,"h":835},"frameWidthPx":0,"mountBorderPx":0}
  },
  "20x20_s": {
    "sizeKey": "20x20",
    "orientation": "s",
    "sizeMm": {"w":508,"h":508},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":332,"y":582,"w":837,"h":837},"artwork":{"x":332,"y":582,"w":837,"h":837},"frame":{"x":297,"y":547,"w":907,"h":907},"frameWidthPx":35,"mountBorderPx":0},
    "framed_m1": {"window":{"x":414,"y":664,"w":673,"h":673},"artwork":{"x":332,"y":582,"w":837,"h":837},"frame":{"x":297,"y":547,"w":907,"h":907},"frameWidthPx":35,"mountBorderPx":82},
    "unframed": {"window":{"x":297,"y":547,"w":906,"h":906},"artwork":{"x":297,"y":547,"w":906,"h":906},"frameWidthPx":0,"mountBorderPx":0}
  },
  "30x30_s": {
    "sizeKey": "30x30",
    "orientation": "s",
    "sizeMm": {"w":762,"h":762},
    "canvas": {"w":1500,"h":2000},
    "framed_m0": {"window":{"x":237,"y":487,"w":1026,"h":1026},"artwork":{"x":237,"y":487,"w":1026,"h":1026},"frame":{"x":209,"y":459,"w":1082,"h":1082},"frameWidthPx":28,"mountBorderPx":0},
    "framed_m1": {"window":{"x":318,"y":568,"w":864,"h":864},"artwork":{"x":237,"y":487,"w":1026,"h":1026},"frame":{"x":209,"y":459,"w":1082,"h":1082},"frameWidthPx":28,"mountBorderPx":81},
    "unframed": {"window":{"x":209,"y":459,"w":1083,"h":1083},"artwork":{"x":209,"y":459,"w":1083,"h":1083},"frameWidthPx":0,"mountBorderPx":0}
  }
};



try {
  const m = window.__ES_WINDOW_MAP__ || {};
  const w24 = m["24x30_p"]?.framed_m0?.window;
  console.log("[ES overlay] window map script loaded", {
    keys: Object.keys(m).length,
    has_16x20_p: !!m["16x20_p"],
    has_24x30_p: !!m["24x30_p"],
    "24x30_p.window(framed_m0)": w24 ? { w: w24.w, h: w24.h } : null,
  });
} catch {}

